import React, {use, useEffect, createContext} from "react";
import PropTypes from "prop-types";
import {useNavigate, useParams} from "react-router";
import {useQuery} from "@apollo/client";
import {useRegScoutCore} from "../../../resources/RegScoutCoreProvider";
import {GET_REGULATION} from "../queries";
import {configureRegulation} from "../utils/dataTransformers";
import {isNull} from "underscore";

export const DetailDataContext = createContext({
  data: {},
  loading: true,
});

export const DetailDataProvider = ({children}) => {
  const {isPlatform} = useRegScoutCore();
  const {id} = useParams();

  const navigate = useNavigate();

  const {data, loading} = useQuery(GET_REGULATION, {
    variables: {id: parseInt(id, 10)},
  });

  useEffect(() => {
    if (data && isNull(data?.regulation)) {
      navigate(!isPlatform ? "/" : "/compliance/research");
    }
  }, [data]);

  return (
    <DetailDataContext value={{
      data: loading || !data || isNull(data?.regulation) ? {} : {...configureRegulation(data?.regulation, data?.tagTypes)},
      loading,
    }}>
      {children}
    </DetailDataContext>
  );
};

DetailDataProvider.propTypes = {
  children: PropTypes.any,
};

export const useDetailData = () => {
  return use(DetailDataContext);
};

